import {
  squareWebUrl,
  loungeWebUrl,
  knowledgeWebUrl,
  portalWebUrl,
  memberRegistrationUrl,
  jobNurseSenkaUrl,
  recruitNurseSenkaUrl,
  njbUrl,
} from './baseUrl';
import { generateAuthorizationUrl } from './generateAuthorizationUrl';

import type { AuthorizationRequest } from '../../types/AuthorizationRequest';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

export const innerNavigationUrls = (appEnv: AppEnv) => ({
  // トップ
  top: portalWebUrl(appEnv),
  // しゃべる
  lounge: loungeWebUrl(appEnv),
  // 読む
  square: squareWebUrl(appEnv),
  // 学ぶ
  knowledge: knowledgeWebUrl(appEnv),
  // 働く
  working: `${portalWebUrl(appEnv)}/working`,
});

// Footer内に存在するリンクに設定するURL一覧
// eslint-disable-next-line import/prefer-default-export
export const footerMenuUrls = (
  appEnv: AppEnv,
  authorizationRequest: AuthorizationRequest,
) => ({
  // ナース専科とは
  description: `${knowledgeWebUrl(appEnv)}/nurse-senka`,
  // ヘルプ
  help: `${portalWebUrl(appEnv)}/helps`,
  // お問い合わせ
  contact: `${portalWebUrl(appEnv)}/contacts`,
  // 利用規約
  termsOfService: `${portalWebUrl(appEnv)}/policies/terms`,
  // 運営会社
  operatingCompany: 'https://www.bm-sms.co.jp',
  // 個人情報について
  privacyPolicy: `${portalWebUrl(appEnv)}/policies/privacy`,
  // 広告掲載について
  advertisements: `${portalWebUrl(appEnv)}/contacts`,
  // 特定商取引法に基づく表示
  termsOfSale: `${portalWebUrl(appEnv)}/hoken/tokushoho`,
  // 会員登録
  memberRegistration: memberRegistrationUrl(appEnv),
  // ログイン
  login: generateAuthorizationUrl(appEnv, authorizationRequest),
  // ナース専科 就職
  recruitNurseSenka: recruitNurseSenkaUrl(appEnv),
  // ナース専科 求人ナビ
  jobNurseSenka: jobNurseSenkaUrl(appEnv),
  // ナース専科 転職
  njb: njbUrl(appEnv),
});
